var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary-secondary-btn-wrapper"},[_c('v-btn',{staticClass:"mr-4 btn--primary-alturos-blue",on:{"click":_vm.confirm}},[_vm._v(" \n\t\t"+_vm._s(_vm.labelPrimaryAction)+"\n\t")]),_c('v-btn',{staticClass:"mr-4",attrs:{"color":"secondary"},on:{"click":_vm.reject}},[_vm._v("\n\t\t"+_vm._s(_vm.labelSecondaryAction)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }